/**
 * Read a post-login redirect from `?next=` and only allow same-origin paths
 * (must start with `/` and not `//` or `/\`) to avoid open-redirect abuse.
 * Also rejects bouncing back into `/auth/*` which would loop the user.
 *
 * The ONE rule set every post-authentication landing point resolves `next`
 * through — login (AuthLayout.onLoginSuccess), MFA setup, MFA recovery, email
 * OTP — so none of them can drift from this open-redirect guard by
 * re-implementing it. Kept in its own module (not exported from
 * auth-layout.tsx) because that file is a react-refresh component boundary —
 * exporting a non-component from it breaks fast refresh for every component
 * in the file.
 */
export function getSafeNext(search: string): string | null {
  const params = new URLSearchParams(search)
  const raw = params.get('next')
  if (!raw) return null
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return null
  if (raw.startsWith('/auth/')) return null
  return raw
}
